module.exports = __webpack_public_path__ + "img/yingxiao.7e0a9877.png";